module.exports = __webpack_public_path__ + "static/microsoft-074c2df9e09f577c9f426834bdb8d152.png";